import { memo, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import SafetyAlarmCreatorFragment from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/SafetyAlarmCreatorFragment/SafetyAlarmCreatorFragment";
import { LOADING } from "@coworker/apprestructured/src/task-management/loading";

function DecisionWithModalDemo() {
  const [task, setTask] = useState<Record<string, unknown>>({
    details: { safety_alarm: false },
  });

  return (
    <Demo>
      <Name>DecisionWithModal</Name>
      <Highlight>
        <SafetyAlarmCreatorFragment
          configProps={{ field: "details.safety_alarm" }}
          commonProps={{
            blockInput: false,
            task,
            onTaskChange: setTask,
            showValidation: false,
            taskType: LOADING,
          }}
        />
      </Highlight>
    </Demo>
  );
}

export default memo(DecisionWithModalDemo);
